<template>
  <div class="input-close-wrap">
    <input
      class="app-t-input"
      type="text"
      enterkeyhint="done"
      v-model="modelValue"
      v-cursor-end
      @keydown.enter.prevent="(e) => (e.target as HTMLInputElement).blur()"
    />

    <button type="button" class="close" v-if="modelValue !== ''" @click="reset">
      <img :src="'/images/mobile/icon/close.svg'" alt="" />
    </button>
  </div>

  <div class="btn-area">
    <button type="button" class="l-btn primary-btn" :disabled="!modelValue" @click="$emit('confirm', modelValue)">
      <span>{{ t('label_change') }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
const modelValue = defineModel('payload', { default: '' });
defineEmits(['confirm', 'close']);

const { t } = useI18n();

const reset = () => {
  modelValue.value = '';
};
</script>

<style scoped lang="scss">
.input-close-wrap {
  margin: 2rem 0;
  .app-t-input {
    padding-right: 2.75rem;
  }
  position: relative;
  .close {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    padding: 0.25rem;
  }
}
</style>
